import React from 'react';

import { ProgressEvent } from '../types/progress';
import './PostProgressBar.css';

const PHASE_LABEL: Record<string, string> = {
  queued: 'Queued',
  encoding: 'Encoding',
  uploading: 'Uploading',
  publishing: 'Publishing',
  rendering: 'Rendering',
  preparing: 'Preparing',
  done: 'Done',
  error: 'Failed',
};

interface PostProgressBarProps {
  event: ProgressEvent | null;
}

export default function PostProgressBar({ event }: PostProgressBarProps) {
  if (!event) {
    return (
      <div className="post-progress">
        <div className="post-progress-meta">
          <span className="post-progress-phase">Starting…</span>
        </div>
        <div className="post-progress-track">
          <div className="post-progress-fill indeterminate" style={{ width: '15%' }} />
        </div>
      </div>
    );
  }
  const { phase, percent = 0, message = '', platform } = event;
  const label = PHASE_LABEL[phase] || phase;
  const isError = phase === 'error';
  const pct = Math.max(0, Math.min(100, percent));
  return (
    <div className={`post-progress${isError ? ' is-error' : ''}`}>
      <div className="post-progress-meta">
        <span className="post-progress-phase">
          {label}
          {platform ? ` · ${platform}` : ''}
        </span>
        <span className="post-progress-percent">{Math.round(pct)}%</span>
      </div>
      <div className="post-progress-track">
        <div className="post-progress-fill" style={{ width: `${pct}%` }} />
      </div>
      {message && <div className="post-progress-message">{message}</div>}
    </div>
  );
}
